import { now, offsetDateTimeToMs } from "@freightsimple/time/helpers";
import { useCallback, useEffect, useState } from "react";
import { isDemo } from "@/Environment";

const STORAGE_KEY = "demoLabelHidden";
// 1 week: balances “hide for a while” with “don’t persist forever” if user returns later
const ONE_WEEK_MS = 6048e5;

const readHiddenState = (): boolean => {
  const expiryTimestamp = localStorage.getItem(STORAGE_KEY);
  if (!expiryTimestamp) return false;

  const expiryTime = parseInt(expiryTimestamp, 10);
  if (isNaN(expiryTime)) return false;
  return expiryTime > offsetDateTimeToMs(now());
};

const writeHiddenState = (isHidden: boolean): void => {
  if (isHidden) {
    const expiryTime = offsetDateTimeToMs(now()) + ONE_WEEK_MS;
    localStorage.setItem(STORAGE_KEY, expiryTime.toString());
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
};

export function useNavBarDemoLabelHidden() {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (isDemo()) {
      setIsHidden(readHiddenState());
    }
    // setIsHidden is stable so adding it as a dependency would be unnecessary.
    // Run once on mount to read initial state from localStorage
  }, []);

  const setDemoLabelHidden = useCallback((hidden: boolean) => {
    // Always update state so the button hide works in all environments
    setIsHidden(hidden);
    if (isDemo()) {
      writeHiddenState(hidden);
    }
  }, []);

  return { isDemoHidden: isHidden, setDemoLabelHidden };
}
